import React, { useState } from 'react';
import { generatedDocApi } from '@/services/api/endpoints';
import { Download, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface GeneratedDocumentLinkProps {
  generatedDocId: string;
  documentName: string;
  className?: string;
}

export const GeneratedDocumentLink: React.FC<GeneratedDocumentLinkProps> = ({
  generatedDocId,
  documentName,
  className = '',
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDownload = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      setIsDownloading(true);
      setError(null);

      // Download do documento
      const blob = await generatedDocApi.download(generatedDocId);

      // Criar link de download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${documentName}.docx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

    } catch (err) {
      console.error('[GeneratedDocumentLink] Download error:', err);
      setError('Erro ao baixar documento');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div
      className={`flex items-center justify-between ${className}`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-center gap-2 truncate">
        <span className="truncate" title={documentName}>📄 {documentName}</span>
        {error && <span className="text-red-500 text-xs ml-2">{error}</span>}
      </div>
      <Button
        size="sm"
        variant="outline"
        onClick={handleDownload}
        disabled={isDownloading}
        className="shrink-0 h-7 text-xs flex items-center gap-1.5 border-[#10b981]/50 text-[#10b981] hover:bg-[#10b981] hover:text-white transition-colors"
        title={`Baixar ${documentName}.docx`}
      >
        {isDownloading ? (
          <>
            <Loader2 className="w-3.5 h-3.5 animate-spin" />
            Baixando...
          </>
        ) : (
          <>
            <Download className="w-3.5 h-3.5" />
            Download DOCX
          </>
        )}
      </Button>
    </div>
  );
};

export default GeneratedDocumentLink;